import React from "react";

const TemarioCursoRCP = () => {
    return (
        <div className="temario-container border w-100 p-5">
            <b>{"Reconocimiento de la patología"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Manejo de la escena"}</span></li>
                <li><span className="fw-light">{"Aprenderás lo esencial para garantizar la seguridad tanto de la víctima como de quien brinda ayuda al realizar RCP."}</span></li>
                <li><span className="fw-light">{"Seguridad personal"}</span></li>
                <li><span className="fw-light">{"Víctima"}</span></li>
                <li><span className="fw-light">{"Emergencias"}</span></li>
            </ul>
            <br /><br />
            <b>{"Cadena de la vida"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Eslabones esenciales que deben seguirse en una secuencia lógica durante una emergencia médica, como un paro cardiorrespiratorio, para aumentar las posibilidades de supervivencia de la víctima."}</span></li>
            </ul>
            <br /><br />
            <b>{"Cómo llevar a cabo una correcta técnica de RCP"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Posición de seguridad"}</span></li>
                <li><span className="fw-light">{"Compresiones torácicas"}</span></li>
                <li><span className="fw-light">{"Diferencia en la RCP para niños y lactantes"}</span></li>
            </ul>
            <br /><br />
            <b>{"Uso de DEA en ambientes cardioprotegidos"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Introducción al DEA"}</span></li>
                <li><span className="fw-light">{"Cómo utilizar un DEA en una emergencia"}</span></li>
            </ul>
        </div>
    );
};

export default TemarioCursoRCP;
